
export default class GlobalSatisfactionWin {
    constructor(ajax, client, hotelId) {
        this.hotelId = hotelId
        this.prex = client === 'vue' ? 'api/' : ''
        this.$http = ajax
        this.iframe = window.top !== window
        this.newVersion = false
        this.model = {
            scoreDetail: {},
            star: null,
            des: null,
            title: ''
        }
        this.path = this.getPath()
        this.config = {
            system: {
                title: '请对直客通后台界面的使用体验满意度打分(操作流畅性及使用友好度)'
            }
        }
        this.bgUrl = `https://static.zhiketong.com/static/img/satisfactionBg.png`
        this.getConfig()
    }
    getConfig() {

        return this.$http({
            method: 'GET',
            url: this.prex + `merchant-api/config/getHotelConfigAll`
        }).then(res => {
            let resVal = (res && res.data && res.data.data) || (res && res.data) || res
            this.model.hotelconfig = resVal
            if (resVal.ENABLE_UI_UPGRADE_ALL === '1' || (resVal.ENABLE_TICKET_PRODUCT_ABTEST && resVal.ENABLE_TICKET_PRODUCT_ABTEST.split(',').includes(this.hotelId))) {
                this.newVersion = true
            }
            this.init()
        }).catch(err => {
            console.error('酒店配置的获取失败')
        })
    }
    init() {
        if (location.host.indexOf('test5') >= 0) {
            return false
        }
        let dashGuide = localStorage.getItem('dashBoardGuid')
        if (!this.iframe && (!dashGuide || (dashGuide && Number(dashGuide) >= 5))) {
            if (!localStorage.getItem(`global:ST${this.path}`)) { // 初始化赋值一次，放置微评论时，每次都弹出
                this.setLocalStorage()
            }
            if (!localStorage.getItem(`global:STsystem`) && this.path === 'dashboard') { // 初始化赋值一次，放置微评论时，每次都弹出
                this.path = 'system'
                this.getglobalSatisfactionData(this.path)
            } else {
                this.getglobalSatisfactionData()
            }
        }
    }
    bindEvent() {
        let CloseDom = this.getId('globalSatisfactionWinClose')
        if (CloseDom) {
            CloseDom.onclick = this.globalSatisfactionWinClose.bind(this)
        }
        let openBtn = this.getId('openglobalSatisfactionWin')
        if (openBtn) {
            openBtn.onclick = () => {
                this.removeItem()
                this.path = this.getPath()
                this.getglobalSatisfactionData('reappend')
                    .then(() => {
                        this.model.star && this.star(this.model.star)
                    })
            }
        }
        let openglobalSatisfactionWinSystemBtn = this.getId('openglobalSatisfactionWinSystem')
        if (openglobalSatisfactionWinSystemBtn) {
            openglobalSatisfactionWinSystemBtn.onclick = () => {
                this.path = 'system'
                // this.removeItem('system')
                this.getglobalSatisfactionData('reappend')
                    .then(() => {
                        this.model.star && this.star(this.model.star)
                    })
            }
        }

        let starList = document.querySelectorAll('.Messagestar')
        starList.forEach((item, ind) => {
            item.onclick = this.star.bind(this, ind + 1)
        })
        let waitToWrite = this.getId('waitToWrite')
        if (waitToWrite) {
            waitToWrite.onclick = this.globalSatisfactionWinClose.bind(this)
        }
        let waitToWritelater = this.getId('waitToWritelater')
        if (waitToWritelater) {
            waitToWritelater.onclick = () => {
                this.globalSatisfactionfailClose.bind(this)
                location.reload()
            }
        }
        let reopen = this.getId('reopen')
        if (reopen) {
            reopen.onclick = () => {
                openBtn.onclick()
                waitToWritelater.click()
            }
        }

        let submitMessage = this.getId('submitMessage')
        if (submitMessage) {
            submitMessage.onclick = this.globalSatisfactionSubmit.bind(this)
        }
        let successClose = this.getId('globalSatisfactionWinSuccessClose')
        if (successClose) {
            successClose.onclick = this.globalSatisfactionSuccessClose.bind(this)
        }
        let failClose = this.getId('globalSatisfactionWinfailClose')
        if (failClose) {
            failClose.onclick = () => {
                waitToWritelater.click()
            }
        }


        let MessageStarDescription = this.getId('MessageStarDescription')
        if (MessageStarDescription) {
            MessageStarDescription.onchange = (ev) => {
                this.model.des = ev.target.value
            }
        }
    }
    globalSatisfactionfailClose() {
        let winDom = this.getId('globalSatisfactionWinfail')
        if (winDom) {
            document.body.removeChild(winDom)
        }
    }
    globalSatisfactionSuccessClose() {
        let winDom = this.getId('globalSatisfactionWinSuccess')
        if (winDom) {
            document.body.removeChild(winDom)
        }
    }
    setLocalStorage() {
        localStorage.setItem(`global:ST${this.path}`, 1)
    }
    getglobalSatisfactionData(type) {
        return this.$http({
            method: 'GET',
            url: this.prex + `feedback-api/eb/feedback/get_eb_user_feedback?url=${this.newVersion ? 'NEW' + this.path : this.path}`
        }).then(res => {
            let resVal = (res && res.data && res.data.data) || (res && res.data) || res
            if (resVal.score !== null) {
                this.model.scoreDetail = resVal
                this.model.des = resVal.feedbackDescription
                this.model.star = resVal.score
                if (!type) {
                    this.setLocalStorage()
                }
                this.globalSatisfactionWin(type)
            } else {
                this.model.scoreDetail = null
                this.model.des = ''
                this.model.star = null
                this.star(0)
                this.globalSatisfactionWin(type)
            }
        })
    }
    showSuccess() {
        let winDom = this.getId('globalSatisfactionWinSuccess')
        if (winDom) {
            winDom.style.display = 'block'
            let temp = setTimeout(() => {
                this.getId('globalSatisfactionWinSuccessClose').click()
                clearTimeout(temp)
            }, 2000);
        }
    }
    globalSatisfactionSubmit() {
        this.getId('MessageStarError').style.display = 'none'
        if (!this.model.star) {
            this.getId('MessageStarError').style.display = 'block'
        } else {
            this.$http({
                method: 'POST',
                url: `${this.prex}feedback-api/eb/feedback/eb_user_feedback`,
                body: {
                    url: this.newVersion ? 'NEW' + this.path : this.path,
                    score: this.model.star,
                    description: this.model.des
                }
            }).then((res) => {
                if ((res.code && res.code === '0') || (!res.code && res)) {
                    this.getId('globalSatisfactionWinClose').click()
                    this.showSuccess()
                } else {
                    this.showError()
                }
            }).catch(err => {
                this.showError()
            })
        }
    }
    showError() {
        let dom = this.getId('globalSatisfactionWinfail')
        if (dom) {
            dom.style.display = 'block'
            this.getId('globalSatisfactionWinClose').click()
            let temp = setTimeout(() => {
                this.getId('globalSatisfactionWinFailClose').click()
                clearTimeout(temp)
            }, 2000);
        }
    }
    getId(id) {
        return document.getElementById(id)
    }
    star(ind) {
        this.model.star = ind
        if (this.getId('MessageStarScoleParent')) {
            this.getId('MessageStarScoleParent').style.display = 'block'
            this.getId('MessageStarScole').innerText = `${ind}分`
            this.getId('MessageStarScoleDes').innerText = this.starDes(ind)
            this.getId('MessageStarError').style.display = 'none'
            let starList = document.querySelectorAll('.Messagestar')
            starList.forEach((item, index) => {
                starList[index].style.backgroundPosition = '-59px -177px'
                if (index < ind) {
                    starList[index].style.backgroundPosition = '-59px -229px'
                }
            })
        }
    }
    starDes(ind) {
        switch (ind) {
            case 1:
                return '非常不满意,体验极差!'
            case 2:
                return '不满意,很难用!'
            case 3:
                return '一般,没什么特别的!'
            case 4:
                return '满意,整体很流畅!'
            case 5:
                return '非常满意,操作简单,舒适度高!'
        }
    }
    globalSatisfactionWinClose() {
        let winDom = this.getId('globalSatisfactionWinHtml')
        if (winDom) {
            document.body.removeChild(winDom)
            this.path !== 'system' && this.removeItem()
        }
    }
    getPath() {
        let path = location.hash && location.hash.replace('#/', '')
        if (path.indexOf('iframe') >= 0) {
            path = atob(path.replace('iframe/', '').replace('/hotel', '').replace(/%\w+/gi, ''))
        }
        return path
    }
    removeItem(path) {
        localStorage.removeItem(`global:ST${path || this.path}`)
    }
    getParentNewLayoutDom(dom) {
        if (dom.parentElement.parentElement.className === 'menu-container ') {
            if (dom.children[0].innerText) {
                return dom.children[0].innerText.replace(/\d+\+?/, "");
            }
            return ""
        } else {
            return this.getParentNewLayoutDom(dom.parentElement)
        }
    }
    getParentNewDom(dom) {
        if (dom.parentElement.className && dom.parentElement.className.indexOf('open') >= 0 && dom.parentElement.className.indexOf('child-li-inner') < 0) {
            return dom.parentElement.children[0].innerText.replace(/\d+\+?/, '')
        } else {
            return this.getParentNewDom(dom.parentElement)
        }
    }
    getTitle() {
        let title = ''
        title = (this.config[this.path] && this.config[this.path].title) || '请对当前界面的使用体验满意度打分(使用体验:操作流畅性及使用友好度)'
        let newLayoutTitleDom = document.querySelector('.ant-menu-item-selected')
        let newTitleDom = !this.iframe && document.querySelector('.zkt-menu-new .active')
        if (newLayoutTitleDom) {
            // 新版菜单
            title = `请对${this.getParentNewLayoutDom(newLayoutTitleDom)}_${newLayoutTitleDom.innerText}的页面使用体验满意度打分(操作流畅性及使用友好度)`
        }
        if (newTitleDom) {
            // 新版菜单
            title = `请对${this.getParentNewDom(newTitleDom)}_${newTitleDom.innerText}的使用体验满意度打分(操作流畅性及使用友好度)`
        }
        if (this.path === 'system') {
            title = (this.config[this.path] && this.config[this.path].title)
        }
        this.model.title = title
        // MessageTitle
        return title
    }
    globalSatisfactionWin(type) {
        this.getTitle()
        let winDom = this.getId('globalSatisfactionWinHtml')
        if (!winDom) {
            let globalSatisfactionWin = document.createElement('div')
            globalSatisfactionWin.setAttribute('id', 'globalSatisfactionWinHtml')
            let globalSatisfactionWinHtml = `
        <div style="position: fixed;display:flex;justify-content:center;align-items: center;left: 0; top: 0; z-index: 100000;width: 100%;height:100%;background: rgba(0,0,0,0.6)" >
          <div style="background:#fff;border-radius:10px;padding:30px;min-width: 508px;min-height: 520px;">
            <div style="width:21px;height:21px;color:#bfbfbf;float:right;margin: -16px -16px 0 0;cursor:pointer;background:url(${this.bgUrl}?a=${Math.random()}) -67px -694px no-repeat transparent;" id="globalSatisfactionWinClose"></div>
            <div class="Messagecontent" style="width:100%;height:auto;float:left;">
              <div class="smile" style="height:142px;width:142px;margin-left:150px;background:url(${this.bgUrl}?a=${Math.random()}) -5px -5px no-repeat transparent;"></div>
              <div style="color:#333;font-size:16px;max-width:320px;text-align:center;font-weight:500;margin:30px auto 25px auto;" id="MessageTitle">${this.model.title}</div>
              <div style="max-width:300px;0;display:flex;margin:10px auto 0 auto;height:35px;">
                <div class="Messagestar Messagestar0" style="height:34px;width:60px;margin-left:12px;cursor:pointer;background-position: -59px -177px;background-image:url(${this.bgUrl}?a=${Math.random()});"></div>
                <div  class="Messagestar Messagestar1" style="height:34px;width:60px;margin-left:12px;cursor:pointer;background-position: -59px -177px;background-image:url(${this.bgUrl}?a=${Math.random()};"></div>
                <div class="Messagestar Messagestar2"  style="height:34px;width:60px;margin-left:12px;cursor:pointer;background-position: -59px -177px;background-image:url(${this.bgUrl}?a=${Math.random()};"></div>
                <div class="Messagestar Messagestar3"  style="height:34px;width:60px;margin-left:12px;cursor:pointer;background-position: -59px -177px;background-image:url(${this.bgUrl}?a=${Math.random()};"></div>
                <div class="Messagestar Messagestar4"  style="height:34px;width:60px;margin-left:12px;cursor:pointer;background-position: -59px -177px;background-image:url(${this.bgUrl}?a=${Math.random()};"></div>
              </div>
              <div id="MessageStarScoleParent"  style="display:none;color: #4C68EF;margin-top:15px;font-size:12px;width:100%;text-align:center;">
                <span id="MessageStarScole" style="font-size:20px;margin-right:10px;font-weight:bold"></span><span style="font-size:14px" id="MessageStarScoleDes"></span>
              </div>
              <div id="MessageStarError" style="display:none;color: #E94260;margin-top:15px;font-size:12px;width:100%;text-align:center;">请填写星级</div>
              <div style="margin-top:80px;height:20px;font-size:12px;color:#808080">我们渴望听到您真实的声音</div>
              <div style="margin-top:15px;">
                <textarea  placeholder="您的意见很重要，来说说吧～"  id="MessageStarDescription" class="form-control" style="background: #f8f8f8;border: 1px solid #bfbfbf;border-radius: 5px;width:100%;height:80px;resize:none;" maxlength="500">${this.model.des || ''}</textarea>
              </div>
              <div style="margin-top:40px;">
                <div style="border: 1px solid #bfbfbf;cursor:pointer;margin:0 15px 0 75px;border-radius: 5px;float:left;width:140px;height:36px;line-height:36px;text-align:center;" id="waitToWrite">残忍拒绝</div>
                <div style="border: 1px solid #4c68ef;cursor:pointer;color:#fff;background:#4c68ef;border-radius: 5px;float:left;width:140px;height:36px;line-height:36px;text-align:center;" id="submitMessage">确&nbsp;认</div>
              </div>
            </div>
          </div>
        </div>
        `
            globalSatisfactionWin.innerHTML = globalSatisfactionWinHtml
            if (!localStorage.getItem(`global:ST${this.path}`) || type === 'reappend' || type === 'system') {
                document.body.appendChild(globalSatisfactionWin)
                this.path === 'system' && this.setLocalStorage()
            }
            let globalSatisfactionWinbtn = document.createElement('div')
            globalSatisfactionWinbtn.setAttribute('id', 'globalSatisfactionWinbtn')
            let globalSatisfactionWinBtnHtml = `
        <div style="position: fixed;cursor:pointer;width:60px;height:159px;right:0px;bottom:30px;z-index:9999;" >
        <div style="width:60px;height:159px;position:relative;cursor:pointer;background:url(${this.bgUrl}?a=${Math.random()}) -46px -470px no-repeat transparent;" >
          <div id="openglobalSatisfactionWinSystem" style="position:absolute;left:0;top:0;width:100%;height:50%;"></div>
          <div id="openglobalSatisfactionWin" style="position:absolute;left:0;top:50%;width:100%;height:50%;"></div>
        </div>
        </div>
        `
            globalSatisfactionWinbtn.innerHTML = globalSatisfactionWinBtnHtml

            let btnDom = this.getId('globalSatisfactionWinbtn')
            !btnDom && document.body.appendChild(globalSatisfactionWinbtn)

            let globalSatisfactionWinSuccess = document.createElement('div')
            globalSatisfactionWinSuccess.setAttribute('id', 'globalSatisfactionWinSuccess')
            globalSatisfactionWinSuccess.style.display = 'none'
            let globalSatisfactionWinSuccessHtml = `
        <div  style="position: fixed;display:flex;justify-content:center;align-items: center;left: 0; top: 0; z-index: 100000;width: 100%;height:100%;background: rgba(0,0,0,0.6)" >
          <div style="background:#fff;border-radius:8px;padding:30px;min-width: 428px;min-height: 220px;">
            <div style="width:21px;height:21px;color:#bfbfbf;float:right;margin: -16px -16px 0 0;cursor:pointer;background:url(${this.bgUrl}?a=${Math.random()}) -67px -694px no-repeat transparent;" id="globalSatisfactionWinSuccessClose"></div>
            <div class="Messagecontent" style="width:100%;height:auto;float:left;">
              <div class="smile" style="height:40px;width:60px;margin-left:170px;margin-top:20px;background:url(${this.bgUrl}?a=${Math.random()}) -59px -287px no-repeat transparent;"></div>
              <div  style="color: #333;margin-top:25px;font-size:16px;width:100%;text-align:center;">
                评论成功!
              </div>
              <div  style="color: #808080;margin-top:25px;font-size:14px;width:100%;text-align:center;">
              感谢您的意见，我们会继续努力哒～
              </div>
            </div>
          </div>
        </div>
        `
            globalSatisfactionWinSuccess.innerHTML = globalSatisfactionWinSuccessHtml
            let successDom = this.getId('globalSatisfactionWinSuccess')
            !successDom && document.body.appendChild(globalSatisfactionWinSuccess)

            let globalSatisfactionWinfail = document.createElement('div')
            globalSatisfactionWinfail.setAttribute('id', 'globalSatisfactionWinfail')
            globalSatisfactionWinfail.style.display = 'none'
            let globalSatisfactionWinfailHtml = `
        <div  style="position: fixed;display:flex;justify-content:center;align-items: center;left: 0; top: 0; z-index: 100000;width: 100%;height:100%;background: rgba(0,0,0,0.6)" >
          <div style="background:#fff;border-radius:8px;padding:30px;width: 428px;min-height: 220px;">
            <div style="width:21px;height:21px;color:#bfbfbf;float:right;margin: -16px -16px 0 0;cursor:pointer;background:url(${this.bgUrl}?a=${Math.random()}) -67px -694px no-repeat transparent;" id="globalSatisfactionWinfailClose"></div>
            <div class="Messagecontent" style="width:100%;height:auto;float:left;">
              <div class="smile" style="height:40px;width:60px;margin-left:170px;margin-top:20px;background:url(${this.bgUrl}?a=${Math.random()}) -59px -353px no-repeat transparent;"></div>
              <div  style="color: #333;margin-top:25px;font-size:16px;width:100%;text-align:center;">
                评论失败
              </div>
              <div  style="color: #808080;margin-top:25px;font-size:14px;width:100%;text-align:left;">
              啊哦，遇到问题，评论失败了呢！这么可爱的你，一定会原谅我，再评一次的对不对？
              </div>
              <div style="margin-top:40px;">
                <div style="border: 1px solid #bfbfbf;cursor:pointer;margin:0 15px 0 40px;border-radius: 5px;float:left;width:140px;height:36px;line-height:36px;text-align:center;" id="waitToWritelater">晚点再评</div>
                <div style="border: 1px solid #4c68ef;cursor:pointer;color:#fff;background:#4c68ef;border-radius: 5px;float:left;width:140px;height:36px;line-height:36px;text-align:center;" id="reopen">重新评论</div>
              </div>
            </div>
          </div>
        </div>
        `
            globalSatisfactionWinfail.innerHTML = globalSatisfactionWinfailHtml
            let failDom = this.getId('globalSatisfactionWinfail')
            !failDom && document.body.appendChild(globalSatisfactionWinfail)
            this.bindEvent()
        } else {
            let btnDom = this.getId('globalSatisfactionWinbtn')
            if (winDom) {
                document.body.removeChild(winDom)
            }
            if (btnDom) {
                document.body.removeChild(btnDom)
            }
        }
    }
}

